import { memoize } from "lodash";
import { observable } from "mobx";

import getCoreTimingStore from "../core-timing-store";

class CoreConnectionStore {
  isOnline = observable.box<boolean>(true);
  online = async () => {
    this.isOnline.set(true);
    await getCoreTimingStore().onOnlineSendData();
  };
  offline = () => {
    this.isOnline.set(false);
    getCoreTimingStore().onOfflineCalculateDate();
  };
  onStartListeners = () => {
    window.addEventListener("online", this.online);
    window.addEventListener("offline", this.offline);
  };
  onKillListeners = () => {
    window.removeEventListener("online", this.online);
    window.removeEventListener("offline", this.offline);
  };
}
const getCoreConnectionStore = memoize(
  () => new CoreConnectionStore(),
  () => 1
);
export default getCoreConnectionStore;
